import { displayDate } from "../../../../../utils/displayDate";
import { MaterialImport, MaterialOrder } from "../../../../../data/entities";
import { ContentWrapper } from "../../../single/Styled";
import { color } from "../../../../../shared/styles";
import WarningTableIcon from "../../../../../shared/svg/WarningTableIcon";
import CustomTable from "../../../../../shared/components/CustomTable";
import { MissingMaterialTableColumn } from "../../../../../configs/productOrder";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../../shared/components/CustomTable/Styled";
import TextBox from "../../../../../shared/components/TextBox";
import { ProductTableText } from "../../../../ProductOrder/single/Styled";
import { WarningMessage } from "../../../../ProductOrder/single/ProductList/Styled";
import { SummaryTableCell, SummaryTableRow } from "../../../single/AddMaterialModal/Styled";
import { StyledNavLink } from "../../../../../shared/styled/TableStyles";
import { formatNumber, formatInternationalNumber } from "../../../../../utils/format";
import React from "react";

interface MaterialRowProps {
    item: any;
}

const MaterialRow = ({ item }: MaterialRowProps) => {
    const isImportedQuantityMatched = item.missing_quantity === item.quantity;
    const backgroundColor = isImportedQuantityMatched
        ? ""
        : color.status.DANGER_LIGHT;
    const selectedQuantityBorderColor = isImportedQuantityMatched
        ? ""
        : color.status.FAIL;

    return !item.isSummary ? (
        <TableRow sx={{ backgroundColor }}>
            <StyledTableCell align="left">
                <StyledNavLink to={`/materials/${item.material.id}`}>
                    {item.material.material_code || item.material.id}
                </StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">{item.material.name}</StyledTableCell>
            <StyledTableCell align="left">
                {formatNumber(item.missing_quantity)}
            </StyledTableCell>
            <StyledTableCell align="left">
                {displayDate(item.due_date)}
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    style={{
                        borderColor: selectedQuantityBorderColor,
                        backgroundColor,
                    }}
                    text={formatInternationalNumber(item.quantity ?? "")}
                    disabled
                />
            </StyledTableCell>
        </TableRow>
    ) : (
        <SummaryTableRow>
            <SummaryTableCell align="left">{item.id}</SummaryTableCell>
            <SummaryTableCell align="left">{item.name}</SummaryTableCell>
            <SummaryTableCell align="left"></SummaryTableCell>
            <SummaryTableCell align="left"></SummaryTableCell>
            <SummaryTableCell align="left"></SummaryTableCell>
        </SummaryTableRow>
    );
};

interface MissingMaterialListProps {
    materialOrder: MaterialOrder;
    mergeMaterialOrder: Function;
    materialImports: MaterialImport[];
}

export const MissingMaterialList = ({
                                        materialImports,
                                    }: MissingMaterialListProps) => {
    const summaryMaterial = {
        id: `Subtotal`,
        name: "",
        isSummary: true,
        due_date: "",
        selectedQuantity: 0,
    };

    let isAllQuantityMatched = true;

    const tableItems = materialImports ? materialImports : [];

    tableItems.forEach((item: any) => {
        if (item.id !== "Subtotal" && item.missing_quantity !== item.quantity) {
            isAllQuantityMatched = false;
        }
    });

    return (
        <ContentWrapper>
            <ProductTableText>
                Danh sách vật tư nhập kho{" "}
                <span
                    style={{
                        color: color.secondary.DARK_GREY,
                        fontSize: "16px",
                        fontWeight: "400",
                    }}
                >
                    ({tableItems.length} vật tư)
                </span>
            </ProductTableText>

            {!isAllQuantityMatched && (
                <WarningMessage>
                    <WarningTableIcon />
                    <span>
                        <span style={{ fontWeight: "700" }}>
                            Lưu ý quan trọng:{" "}
                        </span>
                        Số lượng nhập kho chênh lệch với số lượng yêu cầu.
                    </span>
                </WarningMessage>
            )}

            <CustomTable
                itemList={[...tableItems, summaryMaterial]}
                RowElement={MaterialRow}
                TableColumns={MissingMaterialTableColumn}
                containerStyle={{ maxHeight: "400px" }}
            />

            {tableItems.length === 0 && "Không có vật tư được nhập kho"}
        </ContentWrapper>
    );
};
